module.exports = __webpack_public_path__ + "img/h5_block03.a2b5fe78.webp";